import React from 'react';

export default function Contact() {
  return (
    <div className="min-h-screen bg-gray-50 text-[#1e293b]">
      <div className="max-w-3xl mx-auto px-4 py-12">
        <h1 className="text-3xl font-extrabold mb-4">Contact Us</h1>
        <p className="text-sm text-gray-500 mb-8">We'd love to hear from you</p>
        <div className="space-y-6 leading-7">
          <p>
            For support, feedback, partnerships, or media inquiries, send us an
            email at <a className="text-sky-600" href="mailto:support@flowman.app">support@flowman.app</a>.
          </p>
          <p>
            Include as much detail as possible (browser, steps to reproduce, and
            screenshots) so we can help you faster.
          </p>
          <p>
            This page is a placeholder. Replace with your preferred contact
            workflow when ready.
          </p>
        </div>
      </div>
    </div>
  );
}

